import Component from "../classes/Component"

export default class Form extends Component {
    constructor({ element }){
        super({ element })
    }
    
    addEventListeners() {
        this.inputs = this.element.querySelectorAll('input')
        this.validation(this.inputs)
    }

    validation(entries){
        entries.forEach((input) => {
            input.addEventListener('keypress', (event) => {
                if(event.key === 'Enter' && event.target.type !== 'submit'){
                    event.preventDefault()
                    event.target.form.submit()
                }
            })

            input.addEventListener('change', (event) => {
                // Input::Number,Text,Phone,Password,Textarea
                if(
                    event.target.getAttribute('type') == 'number' ||
                    event.target.getAttribute('type') == 'text' ||
                    event.target.getAttribute('type') == 'tel' ||
                    event.target.getAttribute('type') == 'password' ||
                    event.target.getAttribute('type') == 'textarea'
                ){
                    if (event.target.value != '') { event.target.classList.add('input--valid') }
                    else { event.target.attributes.placeholder.nodeValue.includes('*') ? event.target.classList.add('input--invalid') : null }
                }
                // Input::Email
                else if (event.target.getAttribute('type') == 'email'){
                    if(!event.target.value.includes('@')){ event.target.classList.add('input--invalid') } 
                    else { event.target.classList.add('input--valid') }
                }
                // Input::Url
                else if (event.target.getAttribute('type') == 'url'){
                    if(!event.target.value.includes('http')){ event.target.classList.add('input--invalid') } 
                    else { event.target.classList.add('input--valid') }
                }
                // Input::File
                else if (event.target.getAttribute('type') == 'file'){
                    if (!event.target.value) { event.target.classList.add('input--invalid') }
                    else { event.target.classList.add('input--valid') }
                }
            })
        })
    }
}